<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('followup-date')"
          prop="followupDate"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <date-picker
            v-model="form.followupDate"
            @change="updateModelItem('followupDate', { required: true })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('followup-person')"
          prop="followupPerson"
          class="material-style">
          <el-input
            :value="form.followupPerson"
            @input="form.followupPerson = valueTrimLeft($event)"
            @change="updateModelItem('followupPerson', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-6 col-12">
        <el-form-item
          :label="L10n('remark-subject')"
          prop="remarkSubjectID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.remarkSubjectID"
            @update:model="updateModelItem('remarkSubjectID', { required: true })"
            :fields="{id: 'id', title: 'subject'}"
            :data="dataSourceRemarkSubject.records"
            :isLoading="dataSourceRemarkSubject.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style">
          <el-input
            ref="firstField"
            type="textarea"
            :value="form.remark"
            @input="form.remark = valueTrimLeft($event)"
            @change="updateModelItem('remark', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'

export default {
  name: 'FormDetails',
  mixins: [mixListForm, Form],
  computed: {
    dataSourceRemarkSubject () {
      return this.API('CompanyRemarkSubjects/GetAllDynamic?Select=id,subject&OrderBy=subject')
    }
  }
}
</script>
